"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.copyLottery = copyLottery;
exports.deleteLottery = deleteLottery;
exports.exportLotteryRecord = exportLotteryRecord;
exports.getBonusActivityList = getBonusActivityList;
exports.getBonusList = getBonusList;
exports.getGoodsList = getGoodsList;
exports.getLotteryDetail = getLotteryDetail;
exports.getLotteryList = getLotteryList;
exports.getLotteryRecordList = getLotteryRecordList;
exports.getLotteryWinList = getLotteryWinList;
exports.saveLottery = saveLottery;
exports.sendLotteryPrize = sendLotteryPrize;
exports.toggleLotteryStatus = toggleLotteryStatus;
exports.uploadLotteryImage = uploadLotteryImage;
var _requestAuth = _interopRequireDefault(require("@/utils/requestAuth"));
/**
 * 获取抽奖活动列表
 * @param {Object} query - 查询参数
 */
function getLotteryList(query) {
  return (0, _requestAuth.default)({
    url: '/lottery/list',
    method: 'get',
    params: query
  });
}

/**
 * 获取抽奖活动详情
 * @param {Number} id - 活动ID
 */
function getLotteryDetail(id) {
  return (0, _requestAuth.default)({
    url: "/lottery/".concat(id),
    method: 'get'
  });
}

/**
 * 保存抽奖活动
 * @param {Object} data - 活动数据
 */
function saveLottery(data) {
  return (0, _requestAuth.default)({
    url: '/lottery',
    method: 'post',
    data: data
  });
}

/**
 * 删除抽奖活动
 * @param {Number} id - 活动ID
 */
function deleteLottery(id) {
  return (0, _requestAuth.default)({
    url: "/lottery/".concat(id),
    method: 'delete'
  });
}

/**
 * 启用/禁用抽奖活动
 * @param {Number} id - 活动ID
 */
function toggleLotteryStatus(id) {
  return (0, _requestAuth.default)({
    url: "/lottery/toggleStatus/".concat(id),
    method: 'post'
  });
}

/**
 * 获取抽奖记录列表
 * @param {Object} query - 查询参数
 */
function getLotteryRecordList(query) {
  return (0, _requestAuth.default)({
    url: '/xyAwardSend/lottery/recordList',
    method: 'get',
    params: query
  });
}

/**
 * 获取中奖记录列表
 * @param {Object} query - 查询参数
 */
function getLotteryWinList(query) {
  return (0, _requestAuth.default)({
    url: '/lottery/winList',
    method: 'get',
    params: query
  });
}

/**
 * 导出抽奖记录
 * @param {Object} query - 查询参数
 */
function exportLotteryRecord(query) {
  return (0, _requestAuth.default)({
    url: '/xyAwardSend/lottery/uploadFile',
    method: 'get',
    params: query
  });
}

/**
 * 上传抽奖活动图片
 * @param {File} file - 图片文件
 */
function uploadLotteryImage(file) {
  var formData = new FormData();
  formData.append('file', file);
  return (0, _requestAuth.default)({
    url: '/lottery/uploadImage',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}

/**
 * 获取优惠券活动列表（用于下拉选择）
 */
function getBonusActivityList() {
  return (0, _requestAuth.default)({
    url: '/lottery/bonusActivities',
    method: 'get'
  });
}

/**
 * 获取商品列表（用于下拉选择）
 */
function getGoodsList() {
  return (0, _requestAuth.default)({
    url: '/lottery/goodsList',
    method: 'get'
  });
}

/**
 * 获取优惠券列表（用于下拉选择）
 */
function getBonusList() {
  return (0, _requestAuth.default)({
    url: '/lottery/bonusList',
    method: 'get'
  });
}

/**
 * 复制抽奖活动
 * @param {Number} id - 活动ID
 */
function copyLottery(id) {
  return (0, _requestAuth.default)({
    url: "/lottery/copy/".concat(id),
    method: 'post'
  });
}

/**
 * 发放抽奖奖品
 * @param {Number} id - 抽奖记录ID
 */
function sendLotteryPrize(id) {
  return (0, _requestAuth.default)({
    url: '/xyAwardSend/lottery/sendPrize',
    method: 'post',
    data: {
      id: id
    }
  });
}